module.exports = __webpack_public_path__ + "icon-react.DfJpEzjq.svg";